import { DownOutlined, UpOutlined } from "@ant-design/icons";
import React, { useState } from "react";

import "../FlightRoster.css";
import { formatToTwoDecimal } from "../../../../utils/utils";

const PassengerInfoComponent = ({ isVisible, passengerData, isLoading = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isVisible) return null;

  // Show loading state
  if (isLoading) {
    return (
      <div className="passenger-info-container">
        <div className="passenger-info-content">
          <div className="passenger-count-section">
            <div className="passenger-count-item">
              <span>Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const {
    totalPassengerCount = "0",
    domesticPassengerCount = "0",
    internationalPassengerCount = "0",
    totalScreenedPassengerPayment = "0",
    totalLandingFees = "0",
    totalOverallPayment = "0",
  } = passengerData || {};

  return (
    <div className="passenger-info-container">
      <div
        className="passenger-info-content"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="passenger-count-section">
          <div className="passenger-count-item">
            <span>Total Passenger Count - {totalPassengerCount}</span>
          </div>
          <div className="passenger-count-item">
            <span>Domestic Passenger Count - {domesticPassengerCount}</span>
          </div>
          <div className="passenger-count-item">
            <span>
              International Passenger Count - {internationalPassengerCount}
            </span>
          </div>
          <div
            className="passenger-count-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? <UpOutlined /> : <DownOutlined />}
          </div>
        </div>

        {isExpanded && (
          <div className="payment-info-section">
            <div className="payment-info-item">
              <span>
                Total Payment for Screened Passengers -{" "}
                 $ {formatToTwoDecimal(totalScreenedPassengerPayment)}
              </span>
            </div>
            <div className="payment-info-item">
              <span>
                Total Landing Fees - $ {formatToTwoDecimal(totalLandingFees)}
              </span>
            </div>
            <div className="payment-info-item">
              <span>
                Total Payment Due - $ {formatToTwoDecimal(totalOverallPayment)}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PassengerInfoComponent;
